import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { css } from 'styled-components'
import { useTranslation } from 'react-i18next';
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import 'styled-components/macro'

import { FlexContainer } from 'heliocor-ui';
import CommonTitle from '../CommonTitle'

export default function LightTable({ 
    columns=[], data = [], caption, handleDelete, handleEdit, extraContent={}, title, margin, alternColorOverride 
}) {

    const { t } = useTranslation()
    const handlers = { handleDelete, handleEdit }
    const { component } = extraContent

    const alternType = alternColorOverride && css`&&{tr:nth-child(odd) {background-color: ${props => props.theme.colors[alternColorOverride]}20;}}`

    return (
        <FlexContainer column margin={margin}>
            {title &&  <CommonTitle translate={title}/>}
            <Table size="small" aria-label="structure table">
            {isEmpty(data) && 
                <caption css='&&{padding: 2rem 3rem;font-size: 14px; text-align: center;}'>
                    <i>{t(caption)}</i>
                </caption> }
                <TableHead>
                    <TableRow>
                        { columns.map((column, index) => <TableCell key={index}>{t(column.key)}</TableCell>) }
                    </TableRow>
                </TableHead>
                <TableBody css={alternType}>
                {!isEmpty(data) && data.map(row => (
                    <TableRow key={row.identifier}>
                        { columns.map((col, i) => (
                            <TableCell key={i} css={`&&{width:${columns[i].width}; max-width: auto; ${col.extraStyle ? col.extraStyle : ''}}`}>
                                {col.render ? col.render(row, {...handlers, index: row.identifier}) : row[col.key]}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            {component && <FlexContainer css='margin-right: 1.2rem;'>{component}</FlexContainer>}
        </FlexContainer>
    )
}
